import React, { lazy, Suspense } from "react";
import { useParams } from "react-router-dom";

const DynamicPaperRouter = () => {
    const { slug } = useParams();

    // Dynamically import the paper component
    const PaperComponent = lazy(() =>
        import(`../../pages/papers/${slug}.jsx`)
    );

    return (
        <Suspense fallback={<div style={{ textAlign: "center", padding: "4rem" }}>Loading paper...</div>}>
        <PaperComponent />
        </Suspense>
    );
};

export default DynamicPaperRouter;